import Entity from './entity'
import result from 'lodash/result'
import Color from './color'
import RA from 'ra-config'
import { getColorByCategory } from '../config/colors'
import { slugify } from 'lib/string'

const { categoryList, strategyList } = RA.app.strategies

class Strategy extends Entity {
  static defaults = {
    dataPoints: []
  }

  setup(_params) {
    const category = categoryList.find(item => item.name === this.Category)
    const strategy = strategyList.find(item => item.name === this.Name)

    this.Color = this.getColor()
    this.Key = slugify({ items: [this.Category, this.Name] })
    this.CategoryShortName = result(
      category,
      'shortName',
      this.Category.toUpperCase()
    )
    this.ShortName = result(strategy, 'shortName', '')
    this.Label = this.Name
  }

  getColor() {
    return new Color(getColorByCategory(this.Category))
  }
}

export default Strategy



// WEBPACK FOOTER //
// ./src/entities/strategy.js